import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../store";
import _ from "lodash";
import TransfertArticleType from "../../../Types/Entites/TransfertArticle/TransfertArticleType";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { SelectedOrganisationId } from "../Auth/authSlice";

export const createTransfertApi = createAsyncThunk(
  "transferarticle/createTransfertApi",
  async (data: any[], { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "transferarticle/createTransfertApi",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const getlesDemandeTransfertApi = createAsyncThunk(
  "transferarticle/getlesDemandeTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "transferarticle/getlesDemandeTransfertApi/" +
          data.organisation +
          "/" +
          data.societe +
          "/" +
          data.indexItem +
          "/" +
          data.etat,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const getlesDemandeTransfertSocieteApi = createAsyncThunk(
  "transferarticle/getlesDemandeTransfertSocieteApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "transferarticle/getlesDemandeTransfertSocieteApi/" +
          data.organisation +
          "/" +
          data.societe +
          "/" +
          data.indexItem +
          "/" +
          data.etat,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const updateTransfertApi = createAsyncThunk(
  "transferarticle/updateTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "transferarticle/updateTransfertApi/",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const getlesDemandeTransfertCreeApi = createAsyncThunk(
  "transferarticle/getlesDemandeTransfertCreeApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "transferarticle/getlesDemandeTransfertCreeApi/" +
          data.societe_id +
          "/" +
          data.organisation_id +
          "/" +
          data.indexItem +
          "/" +
          data.etat,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const getlesDemandeSocieteTransfertCreeApi = createAsyncThunk(
  "transferarticle/getlesDemandeSocieteTransfertCreeApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "transferarticle/getlesDemandeTransfertCreeApi/" +
          data.societe_id +
          "/" +
          data.organisation_id +
          "/" +
          data.indexItem +
          "/" +
          data.etat,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const annulerTransfertApi = createAsyncThunk(
  "transferarticle/annulerTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "transferarticle/annulerTransfertApi",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

export const approverTransfertApi = createAsyncThunk(
  "transferarticle/approverTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "transferarticle/approverTransfertApi",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

export const confirmTransfertApi = createAsyncThunk(
  "transferarticle/confirmTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "transferarticle/confirmTransfertApi",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const retourTransfertApi = createAsyncThunk(
  "transferarticle/retourTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "transferarticle/retourTransfertApi",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const confirmretourTransfertApi = createAsyncThunk(
  "transferarticle/confirmretourTransfertApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "transferarticle/confirmretourTransfertApi",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const numeroBonApi = createAsyncThunk(
  "transferarticle/numeroBonApi",
  async (organisation_id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "transferarticle/numeroBonApi/" + organisation_id,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

export const creeDistributionApi = createAsyncThunk(
  "transferarticle/creeDistributionApi",
  async (data: any[], { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "transferarticle/creeDistributionApi/",
        data,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
type transfertArticleState = {
  demande_transfer_recp: TransfertArticleType[];
  demande_transfer_cree: TransfertArticleType[];
  demande_transfer_cree_societe: TransfertArticleType[];
  demande_transfer_recp_societe: TransfertArticleType[];
  totalpages: any;
  current_page: any;
};

const initialState: transfertArticleState = {
  demande_transfer_recp: [],
  demande_transfer_cree: [],
  demande_transfer_recp_societe: [],
  demande_transfer_cree_societe: [],
  current_page: 0,
  totalpages: 0,
};

export const TransfertArticleSlice = createSlice({
  name: "transfertArticle",
  initialState,
  reducers: {
    resetPagination: (state) => {
      return {
        ...state,
        current_page: 0,
        totalpages: 0,
        demande_transfer_recp: [],
        demande_transfer_cree: [],
        demande_transfer_recp_societe: [],
        demande_transfer_cree_societe: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createTransfertApi.fulfilled, (state, action) => {
      state.demande_transfer_cree = [
        ...state.demande_transfer_cree,
        ...action.payload.data,
      ];
    });
    builder.addCase(getlesDemandeTransfertApi.fulfilled, (state, action) => {
      state.demande_transfer_recp = action.payload.demandestransfertArticle;
            state.demande_transfer_recp_societe = [];

      state.current_page = action.payload.current_page;
      state.totalpages = action.payload.totalpages;
    });
    builder.addCase(
      getlesDemandeTransfertSocieteApi.fulfilled,
      (state, action) => {
        state.demande_transfer_recp_societe =
          action.payload.demandestransfertArticle;
                state.demande_transfer_recp =[]

        state.current_page = action.payload.current_page;
        state.totalpages = action.payload.totalpages;
      },
    );
    builder.addCase(
      getlesDemandeTransfertCreeApi.fulfilled,
      (state, action) => {
        state.demande_transfer_cree = action.payload.list;
        state.demande_transfer_cree_societe = [];

        state.current_page = action.payload.currentPage;
        state.totalpages = action.payload.totalPages;
      },
    );
    builder.addCase(
      getlesDemandeSocieteTransfertCreeApi.fulfilled,
      (state, action) => {
        state.demande_transfer_cree_societe = action.payload.list;
                state.demande_transfer_cree = [];

        state.current_page = action.payload.currentPage;
        state.totalpages = action.payload.totalPages;
      },
    );
    builder.addCase(updateTransfertApi.fulfilled, (state, action) => {
      const index = state.demande_transfer_recp.findIndex(
        (item) => item._id === action.payload.data._id,
      );

      if (index !== -1) {
        // Remplacer l'ancien élément par le nouveau
        state.demande_transfer_recp[index] = action.payload.data;
      } else {
        // Ajouter le nouvel élément s'il n'existe pas déjà
        state.demande_transfer_recp.push(action.payload.data);
      }
    });
  },
});

export const { resetPagination } = TransfertArticleSlice.actions;

export const Listdemande_transfer_recp = (state: RootState) =>
  state.transfertArticles.demande_transfer_recp;
export const Listdemande_transfer_cree = (state: RootState) =>
  state.transfertArticles.demande_transfer_cree;
export const Listdemande_transfer_cree_societe = (state: RootState) =>
  state.transfertArticles.demande_transfer_cree_societe;
export const Listdemande_transfer_recp_societe = (state: RootState) =>
  state.transfertArticles.demande_transfer_recp_societe;
export const CurrentPage = (state: RootState) =>
  state.transfertArticles.current_page;
export const TotalPages = (state: RootState) =>
  state.transfertArticles.totalpages;

export default TransfertArticleSlice.reducer;
